import Vue from 'vue'
import Router from 'vue-router'
// import Layout from '@/components/Layout'
import routes from './modules/routes'

Vue.use(Router)

// 解决重复点击时会报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

/**
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in breadcrumb (recommend set)
  }
**/
export const constantRoutes = [
    {
        path: '/',
        redirect: '/home'
    },
    /**
     * 登录模块
     */
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index')
    },
    {
        path: '/forget',
        name: 'forget',
        component: () => import('@/views/login/ForgetPwd')
    },
    {
        path: '/print',
        name: 'print',
        component: () => import('@/views/print')
    },
    {
        path: '/print/span',
        name: 'print-span',
        component: () => import('@/views/print/Span')
    },
    {
        path: '/print/span1',
        name: 'print-span1',
        component: () => import('@/views/print/Span1')
    },
    {
        path: '/print/pick-face',
        name: 'print-pick-face',
        component: () => import('@/views/print/pickFace')
    },
    {
        path: '/404',
        component: () => import('@/views/404')
    }
    // {
    //     path: '/register',
    //     name: 'register',
    //     component: () => import('@/views/login/Register')
    // }
]

// export const routes = constantRoutes.concat(debtorRouter, financingRouter, factoringRouter)
export const routesArr = constantRoutes.concat(routes)
export const asyncRoutes = routes
const router = new Router({
    // mode: process.env.VUE_APP_NODE_ENV === 'test' ? 'hash' : 'history',
    mode: 'hash',
    base: process.env.VUE_APP_PUBLIC_PATH,
    scrollBehavior: () => ({ y: 0 }),
    routes: routesArr
})

// uncomment this line to auto manage your keep-alive pages
// auto create new page when you pushing,
// destroy useless page when you going back
// import createHelper from 'vue-router-keep-alive-helper'
// createHelper({Vue,router})

// set replaceStay option to keep page alive when replacing
// createHelper({ Vue, router, replaceStay: ['/basic-services/shop-management/edit'] })

export default router
